import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";

import { AnimatePresence, motion } from "framer-motion";
import { ReactComponent as BlankImg } from "../../assets/imgs/blankImg.svg";
import InfoDropdown from "../Fold2/InfoDropdown";

const MarketingChallanges = () => {
  const dropdownList = [
    {
      id: 0,
      dropdownTitle:
        "You don’t know which ads or channels are driving installs?",

      text: "Grovs shows you which ad, channel, or campaign drives installs and revenue—so you can double down on what works.",
      learnMore: "",
    },
    {
      id: 1,
      dropdownTitle: "Users bounce after the click?",

      text: "No more broken journeys. Smart links guide users to the exact content—on iOS, Android, or web.",
      learnMore: "",
    },
    {
      id: 2,
      dropdownTitle: "You’re stuck waiting on reports (or devs)?",

      text: "Grovs puts campaign data, link creation, and messaging tools in your hands—so you can move fast and prove ROI.",
      learnMore: "",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"marketingChallanges"}>
        <Line>
          <TextWrapper>
            <Title>Your Challenges, Solved</Title>
          </TextWrapper>
        </Line>
        <AnimatePresence>
          <Line>
            <Column>
              {dropdownList.map((item) => (
                <InfoDropdown
                  key={item.id}
                  dropdownTitle={item.dropdownTitle}
                  title={item.title}
                  infoText={item.text}
                  learnMoreClick={item.learnMore}
                />
              ))}
            </Column>
          </Line>
        </AnimatePresence>
      </Container>
    </FullPageContainer>
  );
};

export default MarketingChallanges;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 0 80px 0px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};
  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
`;
